module.exports = __webpack_public_path__ + "img/lawtele1.baf9e20d.png";